import React, { Component } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { H3, Tag, Card, Spinner, Callout } from "@blueprintjs/core";
import { Trans } from "react-i18next";

import {
  EacAuthenticatedGetFetch,
  EacAuthenticatedPutFetch,
} from "../../utils/ExternalAccessControlAuthenticatedFetch";
/*
function reorder(list, start, end) {
    const result = Array.from(list);
    const startIndex = list.findIndex(i => i === start);
    const endIndex = list.findIndex(i => i === end);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
};

function move(source, destination, droppableSource, droppableDestination) {
    const sourceClone = Array.from(source);
    const destClone = Array.from(destination);
    
    let removed = {};
    const removedIndex = sourceClone.findIndex(i => droppableSource.index === i);
    if(removedIndex !== -1) removed = sourceClone.splice(removedIndex, 1);
    else return;

    destClone.splice(droppableDestination.index, 0, removed[0]);
    const result = {};
    result[droppableSource.droppableId] = sourceClone;
    result[droppableDestination.droppableId] = destClone;


    return result;
};
*/
function reorder(list, startIndex, endIndex) {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
}

function move(source, destination, droppableSource, droppableDestination) {
  const sourceClone = Array.from(source);
  const destClone = Array.from(destination);
  const [removed] = sourceClone.splice(droppableSource.index, 1);
  destClone.splice(droppableDestination.index, 0, removed);
  const result = {};
  result[droppableSource.droppableId] = sourceClone;
  result[droppableDestination.droppableId] = destClone;
  return result;
}

const GRID = 2;

const getItemStyle = (isDragging, draggableStyle) => ({
  // some basic styles to make the selected look a bit nicer
  userSelect: "none",
  padding: GRID * 2,
  margin: `0 0 ${GRID}px 0`,
  // change background colour if dragging
  background: isDragging ? "lightgreen" : "white",
  // styles we need to apply on draggables
  ...draggableStyle,
});

const getListStyle = (isDraggingOver) => ({
  background: isDraggingOver ? "lightblue" : "lightgrey",
  padding: GRID,
  margin: "4px",
  minHeight: "80%",
});

export default class CustomInterfaceEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: [],
      remaining: [],
    };
    this.id2List = {
      favorites: "selected",
      leftChoices: "remaining",
    };
  }

  componentDidMount() {
    EacAuthenticatedGetFetch("/config", (res) => {
      let max = 0;
      const resActive = res.active.map((i, index) => {
        max = index;
        return { id: index.toString(), label: i };
      });
      max += 1;
      const resListInterface = res.listInterface.map((i, index) => {
        return { id: (max + index).toString(), label: i };
      });
      this.setState({ selected: resActive, remaining: resListInterface });
      if (this.props.update)
        this.props.update({ selected: resActive, remaining: resListInterface });
    });
  }

  getList = (id) => this.state[this.id2List[id]];

  sendChoiceToServer(choices) {
    this.setState({ loading: true });
    const data = {
      listInterface: this.state.remaining.map((r) => r.label),
      active: this.state.selected.map((s) => s.label),
    };
    EacAuthenticatedPutFetch("/config", data, () => {
      this.setState({ loading: false });
      if (this.props.update)
        this.props.update({
          selected: this.state.selected,
          remaining: this.state.remaining,
        });
    });
  }

  onDragEnd = (result) => {
    const { source, destination } = result;
    // dropped outside the list
    if (!destination) return;

    // dropped on the same area, only the order changed
    if (source.droppableId === destination.droppableId) {
      const selected = reorder(
        this.getList(source.droppableId),
        source.index,
        destination.index
      );

      let state = { selected };

      if (source.droppableId === "leftChoices") state = { remaining: selected };

      this.setState(state, () => {
        this.sendChoiceToServer();
      });
    } else {
      // dropped on the other area
      const result = move(
        this.getList(source.droppableId),
        this.getList(destination.droppableId),
        source,
        destination
      );

      this.setState(
        {
          selected: result.favorites,
          remaining: result.leftChoices,
        },
        () => {
          this.sendChoiceToServer();
        }
      );
    }
  };

  render() {
    if (localStorage.getItem("perm_admin") === "true"){
      return (
        <Card>
          <DragDropContext onDragEnd={this.onDragEnd}>
            <div className="flexbox-center" style={{ marginBottom: 15 }}>
              <div>
                <H3>
                  <Trans>active interfaces</Trans>
                </H3>
                <Droppable droppableId="favorites">
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      style={getListStyle(snapshot.isDraggingOver)}
                    >
                      {this.state.selected.map((item, index) => (
                        <Draggable
                          key={item.id}
                          draggableId={item.id}
                          index={index}
                        >
                          {(provided, snapshot) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              style={getItemStyle(
                                snapshot.isDragging,
                                provided.draggableProps.style
                              )}
                            >
                              {
                                <Tag fill={true} large={true}>
                                  {item.label}
                                </Tag>
                              }
                            </div>
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </div>
              <div>
                <H3>
                  <Trans>available interfaces</Trans>
                </H3>
                <Droppable droppableId="leftChoices">
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      style={getListStyle(snapshot.isDraggingOver)}
                    >
                      {this.state.remaining.map((item, index) => (
                        <Draggable
                          key={item.id}
                          draggableId={item.id}
                          index={index}
                        >
                          {(provided, snapshot) => (
                            <div
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              style={getItemStyle(
                                snapshot.isDragging,
                                provided.draggableProps.style
                              )}
                            >
                              {
                                <Tag fill={true} large={true}>
                                  {item.label}
                                </Tag>
                              }
                            </div>
                          )}
                        </Draggable>
                      ))}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </div>
            </div>
            
          </DragDropContext>
          {this.state.loading ? (
            <Callout intent="warning">
              <div className="flexbox-left">
                <Spinner size={20} />
                <Trans>syncronizing data with the server</Trans>
              </div>
            </Callout>
          ) : (
            <Callout intent="success">
              <Trans>data are syncronized with the server</Trans>
            </Callout>
          )}
        </Card>
      );
    }
    else{
      return (<></>);
    }
  }
}
